import { render, staticRenderFns } from "./ClientForm1.vue?vue&type=template&id=6dfeeaae&scoped=true"
import script from "./ClientForm1.ts?vue&type=script&lang=ts&external"
export * from "./ClientForm1.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfeeaae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dfeeaae')) {
      api.createRecord('6dfeeaae', component.options)
    } else {
      api.reload('6dfeeaae', component.options)
    }
    module.hot.accept("./ClientForm1.vue?vue&type=template&id=6dfeeaae&scoped=true", function () {
      api.rerender('6dfeeaae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/ClientForm1/ClientForm1.vue"
export default component.exports